import { useState, useEffect } from 'react'
import { useAuth } from '../hooks/useAuth'
import { supabase } from '../lib/supabase'
import { OWN_CONTACT_FIELDS } from '../lib/crewPrivacy'
import { CONTACT_LABELS as LABELS, contactPatch, contactError } from '../lib/myDetails'

// My details: any crew login edits its OWN phone, e-mail and emergency contact - nothing else, no Crew Edit needed.
// Writes the login's own crew_private row (sql/test-fixes-5.sql: own-row rule + crew_private_guard, contact fields only);
// the crew record comes from the login's crew_id (Crew Logins page), never from the name.
export default function MyDetails() {
  const { config } = useAuth()
  const crewId = config?.crewId || null
  const [form, setForm] = useState(null)
  const [saving, setSaving] = useState(false)
  const [msg, setMsg] = useState('')
  const [err, setErr] = useState('')

  useEffect(() => {
    if (!crewId) return
    supabase.from('crew_private').select(OWN_CONTACT_FIELDS.join(',')).eq('crew_id', crewId).maybeSingle()
      .then(({ data, error }) => { if (error) setErr(error.message); setForm(Object.fromEntries(OWN_CONTACT_FIELDS.map(k => [k, (data && data[k]) || '']))) })
  }, [crewId])

  async function save() {
    setErr(''); setMsg('')
    const bad = contactError(form)
    if (bad) { setErr(bad); return }
    setSaving(true)
    const { error } = await supabase.from('crew_private').upsert({ crew_id: crewId, client_id: config.id, ...contactPatch(form) }, { onConflict: 'crew_id' })
    setSaving(false)
    if (error) setErr(error.message); else setMsg('Saved.')
  }

  const card = { background: 'var(--hull)', border: '0.5px solid var(--border)', borderRadius: 12, padding: 16, maxWidth: 520 }
  const inp = { width: '100%', padding: '8px 10px', borderRadius: 8, border: '0.5px solid var(--border)', background: 'var(--ink)', color: 'var(--text)', fontSize: 14 }
  if (config?.accountType !== 'crew') return <div style={{ padding: 20, color: 'var(--muted)' }}>My details is for crew logins. The Captain edits crew records on the Crew page.</div>
  if (!crewId) return (
    <div style={{ padding: 20 }}><div style={card}>
      <strong>Your login is not linked to a crew record yet.</strong>
      <div style={{ color: 'var(--muted)', fontSize: 13, marginTop: 6 }}>Ask the Captain to link it on the Crew Logins page (Permissions - crew record). Then you can edit your contact details here.</div>
    </div></div>
  )
  return (
    <div style={{ padding: 20, display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div style={card}>
        <div style={{ fontSize: 15, fontWeight: 700 }}>{config?.crewName || 'My details'}</div>
        <div style={{ color: 'var(--muted)', fontSize: 12.5, marginTop: 4 }}>Your own contact details. Passport, birth date, nationality and seaman's book are changed by the Captain (Crew page).</div>
        {!form ? <div style={{ marginTop: 12, color: 'var(--muted)' }}>Loading{'…'}</div> : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 14 }}>
            {OWN_CONTACT_FIELDS.map(k => (
              <label key={k} style={{ display: 'flex', flexDirection: 'column', gap: 4, fontSize: 12, color: 'var(--muted)' }}>{LABELS[k]}
                <input style={inp} value={form[k]} inputMode={/phone/.test(k) ? 'tel' : k === 'email' ? 'email' : undefined} onChange={e => { const v = e.target.value; setMsg(''); setForm(f => ({ ...f, [k]: v })) }} />
              </label>
            ))}
            {err && <div style={{ color: '#C93B47', fontSize: 13 }}>{err}</div>}
            {msg && <div style={{ color: '#137050', fontSize: 13 }}>{msg}</div>}
            <div><button className="btn btn-primary" disabled={saving} onClick={save}>{saving ? 'Saving…' : 'Save'}</button></div>
          </div>
        )}
      </div>
    </div>
  )
}
